import React from 'react';
import LastUpdatedDateTimeStamp from 'web-library/components/draft-date-time-stamp/LastUpdatedDateTimeStamp';

import { UseFormReturn } from 'react-hook-form';
import { TFunction } from 'react-i18next';
import { Button, Grid } from 'web-library';
import OpsAdminApplicationStatusForm from './OpsAdminApplicationStatusForm';
import { FormUpdateApplication } from '../../../../models';

export interface IDropdown {
  code: string;
  description: string;
}

export interface IApplicationStatusData {
  status: string;
  candidateRemark: string;
  internalRemark: string;
  adminUpdatedByName: string;
  adminUpdatedAt: string;
  lockedByUser?: string;
  editable: boolean;
}

export interface IOpsAdminData {
  putNonNationalExamApplicationStatus: any;
  applicationStatusDropdown: IDropdown[];
  applicationStatusData: IApplicationStatusData;
}

interface IOpsAdminFormProps {
  formData: IOpsAdminData;
  classes: Record<string,string>;
  formHook: UseFormReturn<FormUpdateApplication>;
  handleOpenAuditLog: (e: any) => void;
  t: TFunction<'translation'>;
  isLoadingLastUpdated: boolean;
  hasEditAccess: boolean;
}

const OpsAdminForm = (props: IOpsAdminFormProps) => {
  const {
    formData,
    classes,
    handleOpenAuditLog,
    t,
    isLoadingLastUpdated,
    formHook,
    hasEditAccess,
  } = props;

  return (<>
    {formData.applicationStatusData.editable && hasEditAccess && (
      <OpsAdminApplicationStatusForm
        classes={classes}
        dropdownOptions={formData.applicationStatusDropdown}
        formHook={formHook}
      />
    )}
    <Grid container spacing={0} direction="row" justify="flex-start" alignItems="center">
      <Grid md={4} sm={12}>
        {!isLoadingLastUpdated && (
          <LastUpdatedDateTimeStamp
            lastUpdatedInfo={{
              lastUpdatedTime: formData.applicationStatusData.adminUpdatedAt,
              name: formData.applicationStatusData.adminUpdatedByName,
            }}
          />
        )}
      </Grid>
      <Grid md={2} sm={12}>
        <Button
          variant="text"
          size="small"
          color="primary"
          className={classes.viewLog}
          onClick={handleOpenAuditLog}
        >
          {t('exam->>NonNationalExam.ViewLog')}
        </Button>
      </Grid>
    </Grid>
  </>);
};

export default OpsAdminForm;
